module.exports = __webpack_public_path__ + "img/0-37.7d589339.jpg";